import React from "react";
import { Helmet } from "react-helmet";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import Testimonial from "../components/testimonila/Testimonial";
import Footer from "../components/footer/Footer";
import ContactBanner from "../components/contactbanner/ContactBanner";
import PioneeringChange from "../components/pioneeringChange/PioneeringChange";
import { useTranslation } from "react-i18next";
import IndustriesSection from "../components/newIndustriesSection";
import MegaMenu from "../components/MegaMenu/MegaMenu";

const HireContactPage = () => {
  const { t } = useTranslation("industries");
  const industriesData = t("tabData", { returnObjects: true });
  const industriesSectionContent = t("hireContactIndustriesSection", {
    returnObjects: true,
  });

  const { t: tmetaTitles } = useTranslation("metaTitles");
  const metaTitle = tmetaTitles("contactUsTitle", { returnObjects: false });

  return (
    <>
      <Helmet>
        <title>{metaTitle}</title>
        <meta
          name="description"
          content="Have questions or need assistance? Contact us at Bitsclan IT Solutions for expert AI services, software development & more. Book free consultation now."
        />
      </Helmet>
      <MegaMenu />
      <ContactBanner />

      <IndustriesSection />

      {/* <PioneeringChange
        tabData={industriesData}
        mainHeading={industriesSectionContent?.mainHeading}
        greenHeading={industriesSectionContent?.greenHeading}
        content={industriesSectionContent?.sectionDescription}
      /> */}

      {/* <div className="space-top-future-solution"> */}
      {/* <Testimonial heading={"Empowering Your Vision with Expert Talent & Seamless Collaboration"} /> */}
      {/* </div> */}
      <Footer />
    </>
  );
};

export default HireContactPage;
